<template>
  <div class="page-wrapper">
    <banner />
    <div class="page-container">
      <!-- 左侧内容区 -->
      <div class="content-left">
        <!-- 顶部导航筛选 -->
        <nav-filter />
        <!-- 教师基本信息 -->
        <div class="teacher-info">
          <div class="teacher-avatar">
            <img :src="picUrl + teacherInfo.zhaopian" :alt="teacherInfo.name">
          </div>
          <div class="info-content">
            <div class="name-location">
              <span class="teacher-name">{{teacherInfo.name}}</span>
              <span class="teacher-title">老师</span>
              <span class="location">{{teacherInfo.location}}</span>
              <span class="age">{{teacherInfo.age}}岁</span>
            </div>
            <div class="info-container">
              <div class="info-grid">
                <div class="info-item">
                  <span class="label">职务：</span>
                  <el-tooltip :content="teacherInfo.position" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.position}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">政治面貌：</span>
                  <el-tooltip :content="teacherInfo.political" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.political}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">就职学校：</span>
                  <el-tooltip :content="teacherInfo.school" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.school}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">评级：</span>
                  <el-tooltip :content="teacherInfo.rating" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.rating}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">就职状况：</span>
                  <el-tooltip :content="teacherInfo.jobStatus" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.jobStatus}}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">执教教龄：</span>
                  <el-tooltip :content="teacherInfo.yearsOfTeaching" placement="bottom-start" :show-after="200">
                    <span class="value">{{teacherInfo.yearsOfTeaching}}年</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="stats">
                <div class="stat-item">
                  <img src="@/assets/images/eye.png" alt="浏览" class="stat-icon">
                  <span class="stat-label">浏览</span>
                  <span class="stat-value">{{teacherInfo.views}}</span>

                </div>
                <div class="stat-item" @click="handleShare">
                  <img src="@/assets/images/share.png" alt="分享" class="stat-icon">
                  <span class="stat-label">分享</span>
                  <span class="stat-value">{{teacherInfo.shares}}</span>

                </div>
                <div class="stat-item">
                  <img src="@/assets/images/flower.png" alt="收到花" class="stat-icon">
                  <span class="stat-label">收到花</span>
                  <span class="stat-value">{{teacherInfo.collections}}</span>

                </div>
                <div class="stat-item">
                  <img src="@/assets/images/gift.png" alt="收到礼" class="stat-icon">
                  <span class="stat-label">收到礼</span>
                  <span class="stat-value">{{teacherInfo.likes}}</span>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 操作按钮组 -->
        <div class="action-buttons">
          <el-popover
            placement="bottom"
            trigger="click"
            popper-class="certificate-popover"
            width="auto"
          >
            <template #reference>
              <div class="button-item">
                <img src="@/assets/images/certificate.png" alt="查看证件">
                <span>查看证件</span>
              </div>
            </template>
            <div class="certificate-content">
              <template v-if="teacherInfo.zhengjian">
                <img :src="picUrl + teacherInfo.zhengjian" alt="资质证书" class="certificate-img">
              </template>
              <div v-else class="empty-state">
                <img src="@/assets/images/empty.png" alt="暂无证件" class="empty-icon">
                <p class="empty-text">暂无证件信息</p>
              </div>
            </div>
          </el-popover>
          <el-popover
            placement="bottom"
            trigger="click"
            popper-class="certificate-popover"
            width="auto"
          >
            <template #reference>
              <div class="button-item">
                <img src="@/assets/images/certificate.png" alt="查看文凭">
                <span>查看文凭</span>
              </div>
            </template>
            <div class="certificate-content">
              <template v-if="teacherInfo.wenping">
                <img :src="picUrl + teacherInfo.wenping" alt="文凭" class="certificate-img">
              </template>
              <div v-else class="empty-state">
                <img src="@/assets/images/empty.png" alt="暂无文凭" class="empty-icon">
                <p class="empty-text">暂无文凭信息</p>
              </div>
            </div>
          </el-popover>
          <el-popover
            placement="bottom"
            trigger="click"
            v-model="showMark"
            popper-class="remark-popover"
            width="770"
            @show="handleRemarkClick"
          >
            <template #reference>
              <div class="button-item">
                <img src="@/assets/images/certificate.png" alt="点击备注">
                <span>点击备注</span>
              </div>
            </template>
            <div class="remark-content">
              <div class="remark-out-left">
                <div class="teacher-profile">
                  <div class="teacher-avatar">
                    <img :src="picUrl + teacherInfo.zhaopian" :alt="teacherInfo.name">
                  </div>
                  <h3 class="teacher-name">{{teacherInfo.name}}老师</h3>
                  <p class="teacher-title">{{teacherInfo.position}}</p>
                  <p class="teacher-location">{{teacherInfo.location}}</p>
                  <p class="teacher-record">上次评级：<span class="highlight">优秀</span></p>
                </div>
              </div>
              <div class="remark-right">
                <div class="remark-list" v-show="!showAddForm">
                  <template v-if="remarkList && remarkList.length > 0">
                    <div class="remark-item" v-for="item in remarkList" :key="item.id">
                      <div class="remark-left">
                        <img src="@/assets/images/mark.png" alt="标记" class="mark-icon">
                        <div class="remark-date">{{item.inputtime}}</div>
                      </div>
                      <div class="remark-content-box">
                        <div class="remark-tag" :class="{
                          'highlight': item.pingji === '优秀',
                          'good': item.pingji === '良好',
                          'normal': item.pingji === '中等',
                          'plain': item.pingji === '一般'
                        }">全空间课·{{item.pingji}}</div>
                        <div class="remark-content-text">{{item.content}}</div>
                        <span class="remark-delete" @click="showDeleteRemarkConfirm(item.id)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </div>
                    </div>
                    <!-- 分页 -->
                    <el-pagination
                      v-if="remarkTotal > remarkLimit"
                      background
                      layout="prev, pager, next"
                      :total="remarkTotal"
                      :page-size="remarkLimit"
                      :current-page.sync="remarkPage"
                      @current-change="handleRemarkPageChange"
                    >
                    </el-pagination>
                  </template>
                  <div v-else class="empty-state">
                    <img src="@/assets/images/empty.png" alt="暂无备注" class="empty-icon">
                    <p class="empty-text">暂无备注信息</p>
                  </div>
                </div>

                <!-- 添加备注表单 -->
                <div class="remark-add-form" v-show="showAddForm">
                  <h3 class="form-title">备注信息</h3>
                  <div class="form-content">
                    <textarea
                      v-model="newRemark.content"
                      class="remark-textarea"
                      placeholder="请输入备注内容"
                    ></textarea>
                  </div>
                  <div class="rating-select">
                    <span class="rating-label">本次评级：</span>
                    <div class="rating-buttons">
                      <button
                        class="rating-btn"
                        :class="{ active: newRemark.rating === '差' }"
                        @click="newRemark.rating = '差'"
                      >差</button>
                      <button
                        class="rating-btn"
                        :class="{ active: newRemark.rating === '中等' }"
                        @click="newRemark.rating = '中等'"
                      >中等</button>
                      <button
                        class="rating-btn"
                        :class="{ active: newRemark.rating === '良好' }"
                        @click="newRemark.rating = '良好'"
                      >良好</button>
                      <button
                        class="rating-btn excellent"
                        :class="{ active: newRemark.rating === '优秀' }"
                        @click="newRemark.rating = '优秀'"
                      >优秀</button>
                    </div>
                  </div>
                </div>

                <div class="remark-footer">
                  <el-button size="small" @click="cancelAddRemark" v-if="showAddForm">取消</el-button>
                  <el-button size="small" @click="hiddenMark" v-if="!showAddForm">取消</el-button>
                  <el-button type="primary" size="small" @click="toggleAddForm" v-if="!showAddForm">添加备注</el-button>
                  <el-button type="primary" size="small" @click="submitRemark" v-if="showAddForm">提交</el-button>
                </div>
              </div>
            </div>
          </el-popover>
          <div class="button-item">
            <img src="@/assets/images/certificate.png" alt="发送消息">
            <span>发送消息</span>
          </div>
        </div>

        <!-- 老师简历 -->
        <div class="info-section resume-section">
          <div class="section-header">
            <img src="@/assets/images/resume.png" alt="老师简历" class="header-icon">
            <span class="header-text">老师简历</span>
          </div>
          <div class="section-content">
            {{teacherInfo.jianli}}
          </div>
        </div>

        <!-- 老师致辞 -->
        <div class="info-section policy-section">
          <div class="section-header">
            <img src="@/assets/images/message.png" alt="老师致辞" class="header-icon">
            <span class="header-text">老师致辞</span>
          </div>
          <div class="section-content">
            {{teacherInfo.zhici}}
          </div>
        </div>

        <!-- 课务列表 -->
        <div class="info-section course-section">
          <div class="section-header">
            <img src="@/assets/images/projects.png" alt="课务列表" class="header-icon">
            <span class="header-text">课务列表</span>
            <span class="more" @click="toKewuList(id)">更多 ></span>
          </div>
          <div class="section-content">
            <div class="course-tabs">
              <span
                v-for="(item, index) in kewuList"
                :key="index"
                class="tab-item"
                :class="{ active: activeKewuIndex === index }"
                @click="selectKewu(item, index)"
              >{{item.title}}</span>
            </div>
            <div class="course-info" v-if="activeKewu.id">
              <div class="time">{{activeKewu.inputtime}}</div>
              <div class="title" @click="toKewuDetail(activeKewu.id)">{{activeKewu.content}}</div>
            </div>
          </div>
        </div>

        <!-- 文字课件 -->
        <div class="text-materials-section">
          <div class="section-header">
            <div class="header-left">
              <div class="title-area">
                <img src="@/assets/images/book.png" alt="文字课件" class="header-icon">
                <span class="header-text">文字课件</span>
              </div>
              <div class="header-stats">
                <span>累计阅读：{{textMaterialStats.read}}</span>
                <span>累计留言：{{textMaterialStats.comment}}</span>
              </div>
            </div>
            <span class="more" @click="toTextMaterialList">更多 ></span>
          </div>
          <div class="section-content">
            <div class="material-list">
              <div
                class="material-item"
                v-for="(item, index) in textMaterials"
                :key="index"
                @click="toTextMaterialDetail(item.id)"
              >
                <div class="material-title">
                  {{item.title}}
                  <span class="tag" v-if="item.tag">{{item.tag}}</span>
                </div>
                <div class="material-stats">
                  <span>
                    <img src="@/assets/images/eye.png" alt="浏览">
                    <span>阅读：</span>
                    <span class="read-count">{{item.views}}</span>
                  </span>
                  <span>
                    <img src="@/assets/images/ly.png" alt="留言">
                    <span>留言：</span>
                    {{item.comments}}
                  </span>
                </div>
              </div>
              <div v-if="!textMaterials.length" class="empty-state">
                <img src="@/assets/images/empty.png" alt="暂无文字课件" class="empty-icon">
                <p class="empty-text">暂无文字课件</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 免费视频 -->
        <div class="free-videos-section">
          <div class="section-header">
            <div class="header-left">
              <div class="title-area">
                <img src="@/assets/images/video.png" alt="免费视频" class="header-icon">
                <span class="header-text">免费视频</span>
              </div>
              <div class="header-stats">
                <span>累计阅读：{{freeVideoStats.read}}</span>
                <span>累计留言：{{freeVideoStats.comment}}</span>
              </div>
            </div>
            <span class="more" @click="toVideoCoursewareList('2')">更多 ></span>
          </div>
          <div class="section-content">
            <div class="video-grid">
              <div class="video-item" v-for="item in freeVideos" :key="item.id" @click="toVideoDetail(item.id, 2)">
                <div class="video-cover">
                  <img :src="picUrl + item.cover" alt="视频封面">
                  <div class="video-info-overlay">
                    <span class="views">阅读：{{item.views}} 留言：{{item.comments}}</span>
                  </div>
                </div>
                <div class="video-title">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 付费视频 -->
        <div class="paid-videos-section">
          <div class="section-header">
            <div class="header-left">
              <div class="title-area">
                <img src="@/assets/images/video.png" alt="付费视频" class="header-icon">
                <span class="header-text">付费视频</span>
              </div>
              <div class="header-stats">
                <span>累计阅读：{{paidVideoStats.read}}</span>
                <span>累计留言：{{paidVideoStats.comment}}</span>
              </div>
            </div>
            <span class="more" @click="toVideoCoursewareList('3')">更多 ></span>
          </div>
          <div class="section-content">
            <div class="video-grid">
              <div class="video-item" v-for="item in paidVideos" :key="item.id" @click="toVideoDetail(item.id, 3)">
                <div class="video-cover">
                  <img :src="picUrl + item.cover" alt="视频封面">
                  <div class="video-info-overlay">
                    <span class="views">阅读：{{item.views}} 留言：{{item.comments}}</span>
                  </div>
                </div>
                <div class="video-info">
                  <div class="video-title">{{item.title}}</div>
                  <div class="price">￥{{item.price}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 操作按钮模块 -->
        <div class="info-section operation-section">
          <div class="operation-list">
            <div class="operation-item" :class="{ 'active': operationStats.isLiked }" @click="handleLike">
              <img :src="operationStats.isLiked ? require('@/assets/images/dz-active.png') : require('@/assets/images/dz.png')" alt="点赞" class="operation-icon">
              <span class="operation-text">点赞</span>
              <span class="operation-count">{{operationStats.likeNum}}</span>
            </div>
            <div class="operation-item" :class="{ 'active': operationStats.isCollected }" @click="handleCollect">
              <img :src="operationStats.isCollected ? require('@/assets/images/sc-active.png') : require('@/assets/images/sc.png')" alt="收藏" class="operation-icon">
              <span class="operation-text">收藏</span>
              <span class="operation-count">{{operationStats.collectNum}}</span>
            </div>
            <div class="operation-item" @click="showRatingDialog = true">
              <img src="@/assets/images/pf.png" alt="评分" class="operation-icon">
              <span class="operation-text">评分</span>
              <span class="operation-count">{{operationStats.averageScore}}</span>
            </div>
            <div class="operation-item" @click="handleShowcaseClick">
              <img src="@/assets/images/lw.png" alt="礼" class="operation-icon">
              <span class="operation-text">礼</span>
              <span class="operation-count">99+</span>
            </div>
            <div class="operation-item" @click="showGiftDialog = true">
              <img src="@/assets/images/hd.png" alt="花" class="operation-icon">
              <span class="operation-text">花</span>
              <span class="operation-count">{{operationStats.flowerNum}}</span>
            </div>
            <div class="operation-item" @click="handleShare">
              <img src="@/assets/images/fx.png" alt="分享" class="operation-icon">
              <span class="operation-text">分享</span>
              <span class="operation-count">{{teacherInfo.shares || '0'}}</span>
            </div>
            <div class="operation-item" @click="handleShowcaseClick">
              <img src="@/assets/images/cc.png" alt="橱窗" class="operation-icon">
              <span class="operation-text">橱窗</span>
            </div>
            <div class="operation-item">
              <img src="@/assets/images/more.png" alt="更多" class="operation-icon">
              <span class="operation-text">更多</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧广告区 -->
      <!-- <ad-sidebar /> -->
      <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
    </div>

    <!-- 删除确认弹窗 -->
    <el-dialog
      :visible.sync="showDeleteConfirm"
      :show-close="false"
      width="400px"
      custom-class="delete-confirm-dialog"
      center
    >
      <div class="confirm-content">
        <p>是否确认删除备注内容，删除后无法找回。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDeleteConfirm = false" class="cancel-btn">取消</el-button>
        <el-button type="primary" @click="deleteRemark" class="delete-btn">删除</el-button>
      </span>
    </el-dialog>

    <!-- 送礼物弹窗 -->
    <el-dialog
      :visible.sync="showGiftDialog"
      :show-close="true"
      width="800px"
      custom-class="gift-dialog"
      center
      @open="getGiftList"
    >
      <div class="gift-dialog-content">
        <div class="dialog-left">
          <div class="teacher-profile">
            <img :src="teacherInfo.zhaopian ? picUrl + teacherInfo.zhaopian : require('@/assets/images/teacher.png')" alt="教师头像" class="teacher-avatar">
            <h3 class="teacher-name">{{teacherInfo.name}}老师</h3>
            <p class="teacher-title">{{teacherInfo.position}}</p>
            <p class="teacher-location">{{teacherInfo.location}}</p>
            <p class="teacher-rating">
              <span class="rating-label">上次评级：</span>
              <span class="rating-value">{{teacherInfo.rating}}</span>
            </p>
          </div>
        </div>
        <div class="dialog-right">
          <div class="gift-list">
            <template v-if="!giftLoading && giftList.length > 0">
              <div
                v-for="(gift, index) in giftList"
                :key="index"
                class="gift-item"
                :class="{ 'active': selectedGift === index }"
                @click="selectGift(index)"
              >
                <img :src="gift.image" :alt="gift.name" class="gift-image">
                <div class="gift-name">{{gift.name}}</div>
                <div class="gift-price">¥{{gift.price}}</div>
              </div>
            </template>
            <div v-else-if="giftLoading" class="loading-container">
              <div class="loading-spinner"></div>
              <p>正在加载礼物列表...</p>
            </div>
            <div v-else class="empty-state">
              <img src="@/assets/images/empty.png" alt="暂无礼物" class="empty-icon">
              <p class="empty-text">暂无可用礼物</p>
            </div>
          </div>
        </div>
      </div>
      <div class="gift-footer">
        <div class="footer-left">
          <el-checkbox v-model="agreeProtocol">
            我已阅读并同意<a href="#" class="protocol-link">《赠送协议》</a>
          </el-checkbox>
        </div>
        <div class="footer-center">
          <div class="quantity-control">
            <span class="quantity-label">数量：</span>
            <button @click="decreaseQuantity" class="quantity-btn">-</button>
            <input type="text" v-model="giftQuantity" class="quantity-input" readonly>
            <button @click="increaseQuantity" class="quantity-btn">+</button>
          </div>
          <div class="total-price">
            总计：<span class="price-value">¥{{totalPrice}}</span>
          </div>
        </div>
        <div class="footer-right">
          <el-button @click="showGiftDialog = false">取消</el-button>
          <el-button type="primary" @click="sendGift" :disabled="!agreeProtocol">确认送礼</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 支付二维码弹窗 -->
    <el-dialog
      :visible.sync="showPaymentDialog"
      :show-close="false"
      width="400px"
      custom-class="payment-dialog"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="payment-content">
        <h3 class="payment-title">请使用微信扫码支付</h3>
        <div id="payment-qrcode" class="qrcode-container"></div>
        <p class="payment-tip">请使用微信扫描二维码完成支付</p>
        <div class="payment-footer">
          <el-button type="primary" @click="handlePaymentDialogClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 支付确认弹窗 -->
    <el-dialog
      :visible.sync="showPaymentConfirm"
      width="400px"
      custom-class="payment-confirm-dialog"
      center
    >
      <div class="confirm-content">
        <p>是否确认关闭支付窗口？</p>
        <p class="confirm-tip">请确认是否已完成支付</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPaymentConfirm = false">取消</el-button>
        <el-button type="primary" @click="confirmClosePayment">确认关闭</el-button>
      </span>
    </el-dialog>

    <!-- 评分弹窗 -->
    <el-dialog
      :visible.sync="showRatingDialog"
      width="300px"
      custom-class="rating-dialog"
      center
    >
      <div class="rating-content">
        <h3 class="rating-title">教师评分</h3>
        <div class="rating-stars">
          <el-rate
            v-model="ratingValue"
            :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
            :texts="['极差', '较差', '还行', '推荐', '力荐']"
            show-text
          ></el-rate>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRatingDialog = false">取消</el-button>
        <el-button type="primary" @click="submitRating">确定</el-button>
      </div>
    </el-dialog>
    <v-share ref="share"></v-share>
  </div>
</template>

<script>
import Banner from '@/components/common/Banner'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter'
import vShare from '@/components/common/Share'
import { getEduDetails, getNewKewuSeven, getNnewWenziEight, getNewVideoTen, getEduRemarkList, addEduRemark, deleteEduRemark, getEduFlowerNum, getEduAverageNum, getEduCollectNum, getEduLikeNum, getEduFlowerList, getEduLike, getEduCollect, sendFlower, updatePayStatus, getEduRating, share } from '@/axios/education'
import url from '@/axios/url'
import sign from '@/auth/sign'
import QRCode from 'qrcodejs2'

export default {
  name: 'TeacherDetail',
  components: {
    Banner,
    // AdSidebar,
    vShare,
    vRight,
    NavFilter
  },
  data () {
    return {
      picUrl: url.picUrl,
      appid: 'wzwebapp',
      timestamp: parseInt(new Date().getTime() / 1000),
      id: parseInt(this.$route.query.id),
      type: parseInt(this.$route.query.type),
      teacherInfo: {
        name: '',
        position: '',
        political: '',
        school: '',
        rating: '',
        jobStatus: '',
        yearsOfTeaching: '',
        location: '',
        age: '',
        views: '0',
        shares: '0',
        collections: '0',
        likes: '0',
        zhici: '',
        jianli: ''
      },
      kewuList: [],
      activeKewu: {},
      activeKewuIndex: 0,
      textMaterials: [],
      textMaterialStats: {
        read: '0',
        comment: '0'
      },
      freeVideos: [],
      paidVideos: [],
      freeVideoStats: {
        read: '0',
        comment: '0'
      },
      paidVideoStats: {
        read: '0',
        comment: '0'
      },
      advertisements: [
        {
          title: '网源北京城',
          description: '网源北京城建 beijin.com 网源北京城的网上主页',
          image: '@/assets/images/ad.png'
        },
        {
          title: '盐城水街',
          description: '盐城水街的手写春联，是一道亮丽的风景',
          image: '@/assets/images/ad.png'
        },
        {
          title: '天越展厅',
          description: '本次展览位于展厅，重现历史风采，欢迎参观',
          image: '@/assets/images/ad.png'
        },
        {
          title: '天山路幼儿园',
          description: '天山路幼儿园开于2023年1月，原一部...',
          image: '@/assets/images/ad.png'
        },
        {
          title: '安驰汽车信息咨询',
          description: '安驰汽车为您提供最新资讯，欢迎咨询...',
          image: '@/assets/images/ad.png'
        }
      ],
      remarkFilter: {
        type: '',
        time: 'desc'
      },
      newRemark: {
        type: '',
        content: '',
        rating: ''
      },
      showDeleteConfirm: false,
      showAddForm: false,
      remarkList: [],
      remarkPage: 1,
      remarkTotal: 0,
      remarkLimit: 5,
      remarkLoading: false,
      currentRemarkId: null,
      operationStats: {
        flowerNum: '0', // 花数量
        averageScore: '0', // 评分
        collectNum: '0', // 收藏数量
        likeNum: '0', // 点赞数量
        isLiked: false, // 添加点赞状态
        isCollected: false // 添加收藏状态
      },
      showGiftDialog: false,
      giftList: [],
      selectedGift: null,
      giftQuantity: 1,
      totalPrice: 0.10,
      giftLoading: false,
      agreeProtocol: false,
      showPaymentDialog: false, // 添加支付弹窗显示状态
      paymentQrCode: '', // 添加支付二维码URL
      showPaymentConfirm: false,
      paymentTimer: null,
      orderNumber: null,
      showMark: false,
      showRatingDialog: false,
      ratingValue: 0,
      shareConfig: {
        shareList: ['qzone', 'qq', 'tsina', 'weixin'],
        common: {
          bdText: '',
          bdComment: '',
          bdStyle: '1',
          bdSize: '16',
          bdUrl: 'http://w.gg'
        },
        share: [{
          bdSize: 16
        }],
        // 禁用右侧悬浮分享
        slide: false,
        image: [],
        selectShare: []
      }
    }
  },
  created () {
    this.getTeacherDetails()
    this.getKewuList()
    this.getTextMaterials()
    this.getVideoList(2)
    this.getVideoList(3)
    this.getOperationStats() // 获取操作统计数据

    // 初始化礼物总价
    if (this.giftList.length > 0) {
      this.calculateTotal()
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    }
  },
  methods: {
    handleShowcaseClick () {
      this.$message.warning('该功能暂未开放')
    },
    hiddenMark () {
      this.showMark = false
    },
    getTeacherDetails () {
      const params = {
        appid: this.appid,
        timestamp: this.timestamp,
        id: this.id,
        type: this.type
      }
      const signO = sign(params)
      params.sign = signO

      getEduDetails(params).then(res => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data
          this.teacherInfo = {
            name: data.realname || '',
            position: data.zhiwu || '',
            political: data.politics_status || '',
            school: data.schoolname || '',
            rating: data.pingji || '',
            jobStatus: data.jiuzhi_status || '',
            yearsOfTeaching: data.jiaoling ? `${data.jiaoling}` : '',
            location: data.city && data.position ? `${data.city}-${data.position}` : '',
            age: data.csdate ? this.calculateAge(data.csdate) : '',
            views: data.clickcount || '0',
            shares: data.sharecount || '0',
            collections: data.collectcount || '0',
            likes: data.likecount || '0',
            zhici: data.zhici || '',
            jianli: data.jianli || '',
            zhaopian: data.zhaopian || '',
            wenping: data.wenping || '',
            zhengjian: data.zhengjian || ''
          }
        }
      })
    },
    calculateAge (birthDate) {
      if (!birthDate) return ''
      const birth = new Date(birthDate)
      const now = new Date()
      let age = now.getFullYear() - birth.getFullYear()
      const monthDiff = now.getMonth() - birth.getMonth()
      if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
        age--
      }
      return age.toString()
    },
    showDeleteRemarkConfirm (id) {
      this.currentRemarkId = id
      this.showDeleteConfirm = true
    },
    deleteRemark () {
      if (!this.currentRemarkId) {
        return
      }

      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        beizhu_id: this.currentRemarkId
      }
      const signO = sign(params)
      params.sign = signO

      deleteEduRemark(params).then(res => {
        if (res.data && res.data.code === 200) {
          this.$message.success('删除成功')
          this.getRemarkList()
        } else {
          this.$message.error(res.data.msg || '删除失败')
        }
      }).catch(() => {
        this.$message.error('删除失败')
      }).finally(() => {
        this.showDeleteConfirm = false
        this.currentRemarkId = null
      })
    },
    toggleAddForm () {
      this.showAddForm = true
      this.newRemark = {
        type: '',
        content: '',
        rating: ''
      }
    },
    cancelAddRemark () {
      this.showAddForm = false
    },
    submitRemark () {
      if (!this.newRemark.content) {
        this.$message.warning('请输入备注内容')
        return
      }
      if (!this.newRemark.rating) {
        this.$message.warning('请选择评级')
        return
      }

      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        teacher_id: this.id,
        content: this.newRemark.content,
        pingji: this.newRemark.rating
      }
      const signO = sign(params)
      params.sign = signO

      // 将参数转换为Query String
      const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')

      addEduRemark(queryString).then(res => {
        if (res.data && res.data.code === 200) {
          this.$message.success('添加成功')
          this.getRemarkList() // 重新获取列表
          this.showAddForm = false
          this.newRemark = { // 重置表单
            content: '',
            rating: ''
          }
        } else {
          this.$message.error(res.data.msg || '添加失败')
        }
      }).catch(() => {
        this.$message.error('添加失败')
      })
    },
    getKewuList () {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        teacher_id: this.id
      }
      const signO = sign(params)
      params.sign = signO

      getNewKewuSeven(params).then(res => {
        if (res.data && res.data.code === 200) {
          this.kewuList = res.data.data || []
          if (this.kewuList.length > 0) {
            this.activeKewu = this.kewuList[0]
          }
        }
      })
    },
    selectKewu (item, index) {
      this.activeKewu = item
      this.activeKewuIndex = index
    },
    toKewuList () {
      this.$router.push({
        name: 'SectionList',
        query: { id: this.id }
      })
    },
    toKewuDetail (id) {
      this.$router.push({
        name: 'SectionDetail',
        query: { id }
      })
    },
    getTextMaterials () {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        teacher_id: this.id
      }
      const signO = sign(params)
      params.sign = signO

      getNnewWenziEight(params).then(res => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data.lists || []
          this.textMaterials = data.map(item => ({
            id: item.id,
            title: item.title,
            views: item.clickcount || '0',
            comments: item.liuyancount || '0',
            tag: item.tuijian === '1' ? '推荐' : '',
            fileUrl: item.fileurl,
            chargetype: item.chargetype,
            price: item.price
          }))
          this.textMaterialStats.read = res.data.data.totalclick
          this.textMaterialStats.comment = res.data.data.totalliuyan
        }
      })
    },
    toTextMaterialDetail (id) {
      this.$router.push({
        name: 'TextCoursewareDetail',
        query: { id }
      })
    },
    getVideoList (type) {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        teacher_id: this.id,
        type
      }
      const signO = sign(params)
      params.sign = signO

      getNewVideoTen(params).then(res => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data || {}
          const lists = data.lists || []

          if (type === 2) { // 免费视频
            this.freeVideos = lists.map(item => ({
              id: item.id,
              title: item.title,
              views: item.clickcount || '0',
              comments: item.liuyancount || '0',
              cover: item.fengmian || '',
              fileUrl: item.fileurl || ''
            }))
            this.freeVideoStats = {
              read: data.totalclick || '0',
              comment: data.totalliuyan || '0'
            }
          } else if (type === 3) { // 付费视频
            this.paidVideos = lists.map(item => ({
              id: item.id,
              title: item.title,
              views: item.clickcount || '0',
              comments: item.liuyancount || '0',
              cover: item.fengmian || '',
              fileUrl: item.fileurl || '',
              price: parseFloat(item.price || 0).toFixed(2)
            }))
            this.paidVideoStats = {
              read: data.totalclick || '0',
              comment: data.totalliuyan || '0'
            }
          }
        }
      })
    },
    toVideoDetail (id, type) {
      this.$router.push({ name: 'VideoCoursewareDetail', query: { id, type } })
    },
    getRemarkList () {
      this.remarkLoading = true
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        teacher_id: this.id,
        page: this.remarkPage
      }
      const signO = sign(params)
      params.sign = signO

      getEduRemarkList(params).then(res => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data || {}
          this.remarkList = (data.lists || []).map(item => ({
            id: item.id,
            content: item.content,
            pingji: item.pingji,
            inputtime: item.inputtime
          }))
          this.remarkTotal = parseInt(data.total) || 0
          this.remarkLimit = parseInt(data.limit) || 5
        }
        this.remarkLoading = false
      }).catch(() => {
        this.remarkLoading = false
      })
    },
    handleRemarkPageChange (page) {
      this.remarkPage = page
      this.getRemarkList()
    },
    handleRemarkClick () {
      // 重置页码和表单状态
      this.remarkPage = 1
      this.showAddForm = false
      this.newRemark = {
        content: '',
        rating: ''
      }
      // 获取备注列表
      this.getRemarkList()
    },
    async getOperationStats () {
      const baseParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id
      }

      try {
        // 获取花数量
        const flowerParams = { ...baseParams }
        flowerParams.sign = sign(flowerParams)
        const flowerRes = await getEduFlowerNum(flowerParams)
        if (flowerRes.data && flowerRes.data.code === 200) {
          this.operationStats.flowerNum = flowerRes.data.data.count || '0'
        }

        // 获取评分
        const averageParams = { ...baseParams }
        averageParams.sign = sign(averageParams)
        const averageRes = await getEduAverageNum(averageParams)
        if (averageRes.data && averageRes.data.code === 200) {
          this.operationStats.averageScore = averageRes.data.data.average || '0'
          this.ratingValue = averageRes.data.data.average || 0
        }

        // 获取收藏数量
        const collectParams = { ...baseParams }
        collectParams.sign = sign(collectParams)
        const collectRes = await getEduCollectNum(collectParams)
        if (collectRes.data && collectRes.data.code === 200) {
          this.operationStats.collectNum = collectRes.data.data.count || '0'
          this.operationStats.isCollected = collectRes.data.data.status === 1
        }

        // 获取点赞数量
        const likeParams = { ...baseParams }
        likeParams.sign = sign(likeParams)
        const likeRes = await getEduLikeNum(likeParams)
        if (likeRes.data && likeRes.data.code === 200) {
          this.operationStats.likeNum = likeRes.data.data.count || '0'
          // 获取点赞状态
          this.operationStats.isLiked = likeRes.data.data.status === 1
        }
      } catch (error) {
        console.error('获取操作统计数据失败:', error)
      }
    },
    selectGift (index) {
      this.selectedGift = index
      this.calculateTotal()
    },
    increaseQuantity () {
      this.giftQuantity++
      this.calculateTotal()
    },
    decreaseQuantity () {
      if (this.giftQuantity > 1) {
        this.giftQuantity--
        this.calculateTotal()
      }
    },
    calculateTotal () {
      if (this.selectedGift !== null && this.giftList.length > 0) {
        const price = parseFloat(this.giftList[this.selectedGift].price)
        this.totalPrice = (price * this.giftQuantity).toFixed(2)
      }
    },
    handlePaymentDialogClose () {
      this.showPaymentConfirm = true
    },
    async confirmClosePayment () {
      try {
        const params = {
          appid: this.appid,
          timestamp: parseInt(new Date().getTime() / 1000),
          order_number: this.orderNumber
        }
        const signO = sign(params)
        params.sign = signO

        const res = await updatePayStatus(params)
        if (res.data && res.data.code === 200) {
          const status = res.data.data.trade_state
          switch (status) {
            case 'SUCCESS':
              this.$message.success('支付已完成')
              break
            case 'REFUND':
              this.$message.warning('订单已转入退款')
              break
            case 'NOTPAY':
              this.$message.warning('订单未支付')
              break
            case 'CLOSED':
              this.$message.warning('订单已关闭')
              break
            case 'PAYERROR':
              this.$message.error('支付失败，请稍后重试')
              break
            default:
              this.$message.warning('未知支付状态')
          }
        }
      } catch (error) {
        console.error('获取支付状态失败:', error)
        this.$message.error('获取支付状态失败')
      }
      this.showPaymentConfirm = false
      this.$nextTick(() => {
        this.showPaymentDialog = false
        this.clearPaymentTimer()
      })
    },
    startPaymentStatusCheck () {
      this.clearPaymentTimer()
      this.paymentTimer = setInterval(async () => {
        try {
          const params = {
            appid: this.appid,
            timestamp: parseInt(new Date().getTime() / 1000),
            order_number: this.orderNumber
          }
          const signO = sign(params)
          params.sign = signO

          const res = await updatePayStatus(params)
          if (res.data && res.data.code === 200) {
            const status = res.data.data.trade_state
            if (status === 'SUCCESS') {
              this.$message.success('支付已完成')
              this.clearPaymentTimer()
              this.showPaymentDialog = false
            } else if (status === 'CLOSED') {
              this.$message.warning('订单已关闭')
              this.clearPaymentTimer()
              this.showPaymentDialog = false
            }
          }
        } catch (error) {
          console.error('检查支付状态失败:', error)
        }
      }, 3000)
    },
    clearPaymentTimer () {
      if (this.paymentTimer) {
        clearInterval(this.paymentTimer)
        this.paymentTimer = null
      }
    },
    sendGift () {
      if (this.selectedGift === null) {
        this.$message.warning('请选择礼物')
        return
      }

      if (!this.agreeProtocol) {
        this.$message.warning('请先阅读并同意赠送协议')
        return
      }

      const selectedGift = this.giftList[this.selectedGift]
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        teacherid: this.id,
        id: selectedGift.id,
        number: this.giftQuantity
      }
      const signO = sign(params)
      params.sign = signO

      const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')

      sendFlower(queryString).then(res => {
        if (res.data && res.data.code === 200) {
          if (res.data.data && res.data.data.code_url) {
            this.paymentQrCode = res.data.data.code_url
            this.orderNumber = res.data.data.order_number
            this.showPaymentDialog = true
            this.$nextTick(() => {
              this.generateQRCode()
              this.startPaymentStatusCheck()
            })
          } else {
            this.$message.success(`已成功赠送 ${this.giftQuantity} 个${selectedGift.name}给${this.teacherInfo.name}老师`)
            this.showGiftDialog = false
            this.getOperationStats()
          }
        } else {
          this.$message.error(res.data.msg || '赠送失败')
        }
      }).catch(() => {
        this.$message.error('赠送失败，请稍后重试')
      })
    },
    // 获取礼物列表
    async getGiftList () {
      this.giftLoading = true
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        page: 1
      }
      const signO = sign(params)
      params.sign = signO

      try {
        const res = await getEduFlowerList(params)
        if (res.data && res.data.message === 'success') {
          const data = res.data.data
          this.giftList = data.row.map(item => {
            return {
              id: item.id,
              name: item.flowername,
              image: item.flowerpic ? this.picUrl + item.flowerpic : '',
              price: item.price
            }
          })

          // 初始化选中和总价
          if (this.giftList.length > 0) {
            this.selectedGift = 0
            this.calculateTotal()
          }
        }
      } catch (error) {
        console.error('获取礼物列表失败:', error)
      } finally {
        this.giftLoading = false
      }
    },
    // 添加点赞/取消点赞方法
    async handleLike () {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id
      }
      const signO = sign(params)
      params.sign = signO

      try {
        const res = await getEduLike(params)
        if (res.data && res.data.code === 200) {
          const status = res.data.data.status
          this.operationStats.isLiked = status === 1
          // 更新点赞数量
          this.getOperationStats()
          this.$message.success(status === 1 ? '点赞成功' : '取消点赞成功')
        }
      } catch (error) {
        console.error('点赞操作失败:', error)
        this.$message.error('操作失败，请稍后重试')
      }
    },
    async handleCollect () {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id
      }
      const signO = sign(params)
      params.sign = signO

      try {
        const res = await getEduCollect(params)
        if (res.data && res.data.code === 200) {
          const status = res.data.data.status
          this.operationStats.isCollected = status === 1
          // 更新收藏数量
          this.getOperationStats()
          this.$message.success(status === 1 ? '收藏成功' : '取消收藏成功')
        }
      } catch (error) {
        console.error('收藏操作失败:', error)
        this.$message.error('操作失败，请稍后重试')
      }
    },
    generateQRCode () {
      const qrcodeContainer = document.getElementById('payment-qrcode')
      if (qrcodeContainer) {
        qrcodeContainer.innerHTML = ''
        const qrCode = new QRCode(qrcodeContainer, {
          width: 200,
          height: 200,
          text: this.paymentQrCode,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    toTextMaterialList () {
      this.$router.push({
        name: 'TextCoursewareList',
        query: {
          teacher_id: this.id
        }
      })
    },
    toVideoCoursewareList (type) {
      this.$router.push({
        name: 'VideoCoursewareList',
        query: { teacher_id: this.id, type }
      })
    },
    async submitRating () {
      if (this.ratingValue === 0) {
        this.$message.warning('请选择评分')
        return
      }
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        score: this.ratingValue
      }
      const signO = sign(params)
      params.sign = signO

      try {
        const res = await getEduRating(params)
        if (res.data && res.data.code === 200) {
          this.$message.success('评分成功')
          this.showRatingDialog = false
          this.getOperationStats()
        }
      } catch (error) {
        console.error('评分操作失败:', error)
        this.$message.error('操作失败，请稍后重试')
      }
    },
    handleShare () {
      // 设置分享内容
      const title = `万知教育-${this.teacherInfo.name}老师`
      const address = this.teacherInfo.location ? `（${this.teacherInfo.location}）` : ''
      const shareUrl = window.location.href

      this.shareConfig.common = {
        ...this.shareConfig.common,
        bdText: title + address,
        bdComment: title + address,
        bdUrl: shareUrl,
        onAfterClick: () => {
          this.doShare()
        }
      }

      // 更新分享组件配置
      if (this.$refs.share) {
        this.$refs.share.vshareConfig = this.shareConfig
      }

      // 初始化分享组件
      window._bd_share_config = this.shareConfig
      if (!window._bd_share_main) {
        const src = '/src/assets/js/share.js?cdnversion=' + ~(-new Date() / 36e5)
        const oScript = document.createElement('script')
        oScript.type = 'text/javascript'
        oScript.async = true
        oScript.src = src
        oScript.onload = () => {
          window._bd_share_main.init()
        }
        document.body.appendChild(oScript)
      } else {
        window._bd_share_main.init()
      }

      // 触发分享弹窗
      const shareButton = document.querySelector('.bds_more')
      if (shareButton) {
        shareButton.click()
      }
    },

    doShare () {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id
      }
      const signO = sign(params)
      params.sign = signO

      share(params).then(res => {
        if (res.data && res.data.code === 200) {
          this.$message.success('分享成功')
          // 更新教师信息以刷新分享数
          this.getTeacherDetails()
        } else {
          this.$message.error(res.data.msg || '分享失败')
        }
      }).catch(() => {
        this.$message.error('分享失败，请稍后重试')
      })
    }
  },
  beforeDestroy () {
    this.clearPaymentTimer()
  }
}
</script>
<style lang="less">
.nav-popover {
  padding: 16px;
  min-width: 600px;
  background: #fff;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);

  .subject-list {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px 20px;
    padding: 0;
    margin: 0;

    .subject-item {
      text-decoration: none;
      color: #666666;
      font-size: 13px;
      transition: color 0.3s;
      display: block;
      white-space: nowrap;
      line-height: 1.5;

      &:hover {
        color: #7DBD83;
      }
    }
  }
}

.certificate-popover {
  padding: 0;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .el-popper__arrow {
    display: none;
  }

  .popper__arrow {
    border-top-color: rgba(0, 0, 0, 0.7) !important;

    &::after {
      border-bottom-color: rgba(0, 0, 0, 0.7) !important;
      border-top-color: rgba(0, 0, 0, 0.7) !important;
    }
  }

  .certificate-content {
    width: 400px;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    .certificate-img {
      width: 400px;
      height: auto;
      display: block;
      border-radius: 8px;
    }

    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 0;

      .empty-icon {
        width: 150px;
        height: 150px;
        margin-bottom: 16px;
      }

      .empty-text {
        font-size: 14px;
        color: #999;
        margin: 0;
      }
    }
  }
}

.gift-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;

  .gift-item {
    text-align: center;
    background-color: #fff;
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      border-color: #EF8432;
    }

    &.active {
      border-color: #EF8432;
      box-shadow: 0 0 5px rgba(239, 132, 50, 0.5);
    }

    .gift-image {
      width: 60px;
      height: 60px;
      margin-bottom: 5px;
    }

    .gift-name {
      font-size: 12px;
      color: #333;
      margin-bottom: 2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .gift-price {
      font-size: 14px;
      color: #E4004E;
    }
  }
}

.loading-container {
  grid-column: span 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-radius: 50%;
    border-top: 3px solid #EF8432;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }

  p {
    color: #666;
    font-size: 14px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}

.empty-state {
  grid-column: span 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;

  .empty-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 16px;
  }

  .empty-text {
    color: #999;
    font-size: 14px;
  }
}

.remark-popover {
  padding: 0;
  background: #FFFFFF;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .el-popper__arrow {
    display: none;
  }

  .remark-content {
    display: flex;
    min-height: 400px;

    .remark-out-left {
      width: 148px;
      border-right: 1px solid #EBEEF5;
      background: #f8f8f8;
      padding: 20px 0;

      .teacher-profile {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        .teacher-avatar {
          width: 80px;
          height: 80px;
          border-radius: 4px;
          overflow: hidden;
          margin-bottom: 12px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .teacher-name {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          margin: 0 0 6px;
        }

        .teacher-title {
          font-size: 13px;
          color: #666;
          margin: 0 0 4px;
        }

        .teacher-location {
          font-size: 13px;
          color: #666;
          margin: 0 0 4px;
        }

        .teacher-record {
          font-size: 13px;
          color: #666;
          margin: 0;

          .highlight {
            color: #EF8432;
          }
        }
      }
    }

    .remark-right {
      flex: 1;
      display: flex;
      flex-direction: column;

      .remark-list {
        flex: 1;
        overflow-y: auto;
        padding: 16px;

        .empty-state {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 0;

          .empty-icon {
            width: 150px;
            height: 150px;
            margin-bottom: 16px;
          }

          .empty-text {
            font-size: 14px;
            color: #999;
            margin: 0;
          }
        }

        .remark-item {
          margin-bottom: 16px;
          display: flex;
          align-items: flex-start;
          position: relative;

          &:last-child {
            margin-bottom: 0;
          }

          .remark-left {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            margin-right: 10px;

            .mark-icon {
              width: 28px;
              height: 28px;
              margin-right: 4px;
            }

            .remark-date {
              font-size: 12px;
              color: #3D3D3D;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .remark-content-box {
            flex: 1;
            background-color: #F8F8F8;
            border-radius: 4px;
            padding: 12px;
            position: relative;

            .remark-tag {
              font-size: 12px;
              border-radius: 2px;
              display: inline-block;
              margin-bottom: 8px;
              color: #EF8432;
              background: none;

              &.highlight,
              &.good,
              &.normal,
              &.plain {
                color: #EF8432;
                background: none;
              }
            }

            .remark-content-text {
              font-size: 13px;
              color: #3D3D3D;
              line-height: 1.5;
            }

            .remark-delete {
              position: absolute;
              right: 8px;
              top: 8px;
              color: #999;
              cursor: pointer;
              font-size: 12px;

              &:hover {
                color: #f56c6c;
              }
            }
          }
        }
      }

      .remark-footer {
        padding: 12px 16px;
        border-top: 1px solid #EBEEF5;
        display: flex;
        justify-content: flex-end;
        gap: 12px;
      }
    }
  }
}

/* 删除确认弹窗样式 */
.delete-confirm-dialog {
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 30px 20px 20px;
  }

  .confirm-content {
    text-align: center;
    p {
      font-size: 16px;
      color: #333;
      margin: 0;
      line-height: 1.5;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding-top: 10px;

    .cancel-btn {
      background-color: #f2f2f2;
      border-color: #f2f2f2;
      color: #333;

      &:hover {
        background-color: #e6e6e6;
        border-color: #e6e6e6;
      }
    }

    .delete-btn {
      background-color: #EF8432;
      border-color: #EF8432;

      &:hover {
        background-color: #e67722;
        border-color: #e67722;
      }
    }
  }
}

.remark-add-form {
  flex: 1;
  padding: 16px;

  .form-title {
    font-size: 16px;
    color: #333;
    margin: 0 0 16px 0;
    font-weight: 500;
  }

  .form-content {
    margin-bottom: 20px;

    .remark-textarea {
      width: 100%;
      height: 200px;
      padding: 12px;
      border: none;
      border-radius: 4px;
      background-color: #f5f5f5;
      resize: none;
      font-size: 14px;
      color: #333;
      line-height: 1.5;
      outline: none;

      &::placeholder {
        color: #999;
      }
    }
  }

  .rating-select {
    display: flex;
    align-items: center;

    .rating-label {
      font-size: 14px;
      color: #333;
      margin-right: 12px;
    }

    .rating-buttons {
      display: flex;
      gap: 10px;

      .rating-btn {
        padding: 8px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        background-color: #fff;
        font-size: 14px;
        color: #333;
        cursor: pointer;
        outline: none;
        transition: all 0.3s;

        &:hover {
          border-color: #c6e2ff;
          color: #409eff;
        }

        &.active {
          border-color: #409eff;
          color: #409eff;
          background-color: #ecf5ff;
        }

        &.excellent {
          &:hover {
            border-color: #f8dbbd;
            color: #EF8432;
          }

          &.active {
            border-color: #EF8432;
            color: #fff;
            background-color: #EF8432;
          }
        }
      }
    }
  }
}

.gift-dialog {
  .el-dialog__header {
    padding: 10px;
  }

  .el-dialog__body {
    padding: 0;
  }

  .gift-dialog-content {
    display: flex;
    min-height: 400px;

    .dialog-left {
      width: 160px;
      border-right: 1px solid #EBEEF5;
      padding: 20px;
      display: flex;
      align-items: center;
      flex-direction: column;

      .teacher-profile {
        text-align: center;

        .teacher-avatar {
          width: 130px;
          height: 130px;
          border-radius: 10px;
          margin-bottom: 16px;
          object-fit: cover;
        }

        .teacher-name {
          font-size: 14px;
          color: #333;
          margin-bottom: 8px;
          font-weight: 500;
        }

        .teacher-title {
          font-size: 12px;
          color: #666;
          margin-bottom: 4px;
          text-align: center;
        }

        .teacher-location {
          font-size: 12px;
          color: #666;
          text-align: center;
          margin-bottom: 4px;
        }

        .teacher-rating {
          font-size: 12px;
          text-align: center;

          .rating-label {
            color: #666;
          }

          .rating-value {
            color: #EF8432;
          }
        }
      }
    }

    .dialog-right {
      flex: 1;
      padding: 20px;

      .gift-list {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 12px;
        max-height: 360px;
        overflow-y: auto;

        .gift-item {
          text-align: center;
          background-color: #F8F8F8;
          border: 1px solid #EBEEF5;
          border-radius: 4px;
          padding: 8px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            border-color: #EF8432;
          }

          &.active {
            border-color: #EF8432;
            box-shadow: 0 0 5px rgba(239, 132, 50, 0.5);
          }

          .gift-image {
            width: 60px;
            height: 60px;
            margin-bottom: 5px;
          }

          .gift-name {
            font-size: 12px;
            color: #3D3D3D;
            margin-bottom: 2px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .gift-price {
            font-size: 14px;
            color: #E4004E;
          }
        }
      }

      .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 0;

        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #f3f3f3;
          border-radius: 50%;
          border-top: 3px solid #EF8432;
          animation: spin 1s linear infinite;
          margin-bottom: 10px;
        }

        p {
          color: #666;
          font-size: 14px;
        }
      }

      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 0;

        .empty-icon {
          width: 100px;
          height: 100px;
          margin-bottom: 16px;
        }

        .empty-text {
          color: #999;
          font-size: 14px;
        }
      }
    }
  }

  .gift-footer {
    background-color: #F7F7F7;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #EBEEF5;

    .footer-left {
      .el-checkbox {
        .el-checkbox__input.is-checked {
          +.el-checkbox__label{
          color: #666 !important;
          }
          .el-checkbox__inner {
            background-color: #EF8432;
            border-color: #EF8432;
          }
        }
      }

      .protocol-link {
        color: #666;
        text-decoration: none;
        margin-left: 4px;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .footer-center {
      display: flex;
      align-items: center;
      gap: 20px;

      .quantity-control {
        display: flex;
        align-items: center;
        gap: 8px;

        .quantity-label {
          color: #333;
          font-size: 14px;
        }

        .quantity-btn {
          width: 24px;
          height: 24px;
          background: #fff;
          border: 1px solid #DCDFE6;
          cursor: pointer;
          font-size: 16px;
          line-height: 1;
          color: #606266;
          padding: 0;

          &:hover {
            border-color: #EF8432;
            color: #EF8432;
          }
        }

        .quantity-input {
          width: 40px;
          height: 24px;
          text-align: center;
          border: 1px solid #DCDFE6;
          outline: none;
        }
      }

      .total-price {
        font-size: 14px;
        color: #333;

        .price-value {
          color: #EF8432;
          font-weight: bold;
          font-size: 16px;
        }
      }
    }

    .footer-right {
      display: flex;
      gap: 12px;

      .el-button--primary {
        background-color: #EF8432;
        border-color: #EF8432;

        &:hover {
          background-color: #e67722;
          border-color: #e67722;
        }

        &:disabled {
          background-color: #fab380;
          border-color: #fab380;
        }
      }
    }
  }
}

.payment-dialog {
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .payment-content {
    text-align: center;
    padding: 10px 10px 30px;

    .payment-title {
      font-size: 16px;
      color: #333;
      margin: 20px 0 10px;
    }

    .qrcode-container {
      width: 200px;
      height: 200px;
      margin: 0 auto 10px;
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
    }

    .payment-tip {
      font-size: 14px;
      color: #666;
      margin: 0;
      text-align: center;
    }

    .payment-footer {
      margin-top: 20px;
      text-align: center;

      .el-button {
        background-color: #EF8432;
        border-color: #EF8432;

        &:hover {
          background-color: #e67722;
          border-color: #e67722;
        }
      }
    }
  }
}

.payment-confirm-dialog {
  .confirm-content {
    text-align: center;
    padding: 20px;

    p {
      margin: 0;
      font-size: 16px;
      color: #333;
      line-height: 1.5;

      &.confirm-tip {
        margin-top: 10px;
        font-size: 14px;
        color: #666;
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding-top: 20px;

    .el-button--primary {
      background-color: #EF8432;
      border-color: #EF8432;

      &:hover {
        background-color: #e67722;
        border-color: #e67722;
      }
    }
  }
}

.rating-dialog {
  .rating-content {
    text-align: center;

    .rating-title {
      font-size: 18px;
      color: #333;
      margin: 0 0 20px;
    }

    .rating-stars {
      display: flex;
      justify-content: center;

      .el-rate {
        display: inline-block;
      }
    }
  }

  .dialog-footer {
    justify-content: flex-end;
    display: flex;
    padding-top: 20px;

    .el-button--primary {
      background-color: #EF8432;
      border-color: #EF8432;

      &:hover {
        background-color: #e67722;
        border-color: #e67722;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.page-wrapper {
  background: #f8f8f8;
  min-height: 100vh;
  padding: 0 0 20px;

  .page-container {
    width: 1200px;
    margin: 20px auto 0;
    display: flex;
    gap: 14px;

    .content-left {
      flex: 1;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0 1px 4px rgba(0,0,0,.05);
      padding: 20px;

      .nav-filter {
        margin-bottom: 20px;

        .nav-items {
          display: flex;
          gap: 24px;

          .nav-item {
            text-decoration: none;
            color: #666666;
            font-size: 14px;
            transition: color 0.3s;

            &.active {
              color: #7DBD83;
              font-weight: 500;
            }

            &:hover {
              color: #7DBD83;
            }
          }
        }
      }

      .teacher-info {
        background: transparent;
        box-shadow: none;
        padding: 0;
        display: flex;
        gap: 20px;
        margin-bottom: 20px;

        .teacher-avatar {
          width: 144px;
          height: 144px;
          border-radius: 6px;
          overflow: hidden;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .info-content {
          flex: 1;

          .name-location {
            display: flex;
            align-items: center;
            margin-bottom: 12px;

            .teacher-name {
              font-size: 16px;
              color: #EF8432;
              font-weight: bold;
              margin-right: 8px;
            }

            .teacher-title {
              font-size: 16px;
              color: #EF8432;
              font-weight: bold;
              margin-right: 24px;
            }

            .location {
              font-size: 13px;
              color: #666666;
            }

            .age {
              font-size: 13px;
              color: #666666;
              margin-left: 12px;
            }
          }

          .info-container {
            background: transparent;
            padding: 0;

            .info-grid {
              margin-bottom: 16px;
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 10px;

              .info-item {
                display: flex;
                align-items: center;

                .label {
                  color: #AF8338;
                  font-size: 13px;
                  margin-right: 8px;
                  white-space: nowrap;
                }

                .value {
                  color: #333333;
                  font-size: 13px;
                  max-width: 120px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }

            .stats {
              display: flex;
              align-items: center;
              gap: 24px;
              margin-top: 16px;

              .stat-item {
                display: flex;
                width: 25%;
                align-items: center;
                cursor: pointer;

                .stat-icon {
                  width: 16px;
                  height: 16px;
                  margin-right: 4px;
                }

                .stat-value {
                  color: #EF8432;
                  font-size: 13px;
                }

                .stat-label {
                  color: #3D3D3D;
                  font-size: 13px;
                  margin-right: 4px;

                }
              }
            }
          }
        }
      }

      .action-buttons {
        display: flex;
        gap: 24px;
        margin-bottom: 20px;
        padding: 0;
        background: transparent;
        box-shadow: none;

        .button-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          height: 50px;
          min-width: 182px;
          background: #ffffff;
          cursor: pointer;
          transition: all 0.3s;
          border: 1px solid #F0F0F0;
          border-radius: 11px;

          img {
            width: 38px;
            height: 38px;
          }

          span {
            font-size: 14px;
            color: #333333;
            font-weight: bold;
          }

          &:hover {
            background: #F8F8F8;
          }
        }
      }
    }
  }
}

.content-right {
  width: 330px;

  .ad-container {
    .ad-banner {
      position: relative;
      margin-bottom: 20px;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 1px 4px rgba(0,0,0,.05);

      img {
        width: 100%;
        height: 160px;
        object-fit: cover;
      }

      .banner-text {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 15px;
        background: linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0));

        h2 {
          margin: 0;
          color: #fff;
          font-size: 18px;
          font-weight: normal;
          line-height: 1.4;
        }
      }
    }

    .ad-list {
      background: #fff;
      border-radius: 6px;
      padding: 12px;

      .ad-item {
        overflow: hidden;
        margin-bottom: 14px;
        display: flex;
        align-items: flex-start;
        cursor: pointer;

        &:last-child {
          margin-bottom: 0;
        }

        img {
          width: 144px;
          height: 98px;
          object-fit: cover;
          border-radius: 2px;
          margin-right: 16px;
        }

        .ad-content {
          flex: 1;
          min-width: 0;

          h3 {
            margin: 0 0 8px;
            font-size: 17px;
            color: #3D3D3D;
            font-weight: 500;
            line-height: 1.4;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          p {
            margin: 0;
            color: #666666;
            font-size: 13px;
            line-height: 1.6;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

.info-section {
  background: #FFFFFF;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid #F0F0F0;

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .header-icon {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }

    .header-text {
      font-size: 16px;
      color: #3DB963;
      font-weight: 500;
    }

    .more {
      margin-left: auto;
      font-size: 14px;
      color: #666666;
      cursor: pointer;
    }
  }

  .section-content {
    color: #666666;
    font-size: 14px;
    line-height: 1.6;
  }

  &.resume-section {
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 110px;
      height: 33px;
      background: #3DB963;
      border-radius: 0 0 16px 0;
      z-index: 0;
    }

    .section-header {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      height: 33px;
      display: flex;
      align-items: center;
      padding-left: 16px;

      .header-icon {
        width: 18px;
        height: 18px;
        margin-right: 2px;
      }

      .header-text {
        color: #ffffff;
        font-size: 14px;
        font-weight: normal;
      }
    }

    .section-content {
      position: relative;
      z-index: 1;
      color: #666666;
      font-size: 14px;
      line-height: 1.8;
      padding: 40px 16px 16px;
    }
  }

  &.policy-section,
  &.course-section {
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 110px;
      height: 33px;
      background: #3DB963;
      border-radius: 0 0 16px 0;
      z-index: 0;
    }

    .section-header {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      height: 33px;
      display: flex;
      align-items: center;
      padding-left: 16px;
      width: 100%;

      .header-icon {
        width: 18px;
        height: 18px;
        margin-right: 2px;
      }

      .header-text {
        color: #ffffff;
        font-size: 14px;
        font-weight: normal;
      }

      .more {
        position: absolute;
        right: 0px;
        padding-right: 36px;
        top: 0;
        padding-top: 5px;
        color: #666666;
        font-size: 13px;
        cursor: pointer;
        display: block;
      }
    }

    .section-content {
      position: relative;
      z-index: 1;
      color: #666666;
      font-size: 14px;
      line-height: 1.8;
      padding: 0 16px 16px;
      margin-top: 40px;
    }
  }

  &.course-section {
    &::before {
      background: #EF8432;
    }
  }
}

.course-section {
  .course-tabs {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    background: #F8F8F8;
    border-radius: 4px;
    padding: 4px;
    position: relative;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .tab-item {
      font-size: 13px;
      color: #666666;
      cursor: pointer;
      padding: 4px 12px;
      position: relative;
      border-radius: 4px;
      transition: all 0.3s ease;
      flex-shrink: 0;

      &:hover {
        color: #333333;
      }

      &.active {
        color: #EF8432;
        font-weight: 500;
        background: #FFFFFF;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .course-info {
    .time {
      font-size: 14px;
      color: #999999;
      margin-bottom: 8px;
    }

    .title {
      font-size: 14px;
      color: #333333;
      line-height: 1.6;
      cursor: pointer;
    }
  }
}

.text-materials-section {
  position: relative;
  overflow: hidden;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      background: #E7F4FD;
      height: 100%;
      border-radius: 0 0 8px 0;
      font-size: 13px;

      .title-area {
        display: flex;
        align-items: center;
        background: #3499E1;
        height: 100%;
        padding: 0 20px;
        border-radius: 0 0 16px 0;

        .header-icon {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }

        .header-text {
          color: #FFFFFF;
          font-size: 14px;
          font-weight: normal;
        }
      }

      .header-stats {
        display: flex;
        gap: 16px;
        padding: 0 16px;

        span {
          font-size: 14px;
          color: #666666;
        }
      }
    }

    .more {
      padding: 0 16px;
      color: #666666;
      font-size: 14px;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }

  .section-content {
    padding: 0;

    .material-list {
      .material-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #F0F0F0;
        background: #FFFFFF;
        position: relative;
        cursor: pointer;

        &:last-child {
          border-bottom: none;
        }

        .material-title {
          font-size: 14px;
          color: #333333;
          flex: 1;
          margin-right: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          padding-left: 0;

          .tag {
            display: inline-block;
            font-size: 12px;
            border: 1px solid #EF8432;
            color: #EF8432;
            padding: 1px 6px;
            border-radius: 2px;
            margin-right: 6px;
            line-height: 1.4;
          }
        }

        .material-stats {
          display: flex;
          gap: 16px;
          align-items: center;
          color: #666666;

          span {
            display: flex;
            align-items: center;
            font-size: 13px;
            color: #666666;

            img {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
          }
          .read-count{
            color: #3DB963;
          }
        }
      }
    }
  }
  .empty-state {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0;

    .empty-icon {
      width: 100px;
      height: 100px;
    }

    .empty-text {
      font-size: 12px;
      color: #999;
      margin: 0;
    }
  }
}

.free-videos-section {
  position: relative;
  overflow: hidden;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      background: #E4F2F3;
      height: 100%;
      border-radius: 0 0 8px 0;
      font-size: 13px;

      .title-area {
        display: flex;
        align-items: center;
        background: #3FBABE;
        height: 100%;
        padding: 0 20px;
        border-radius: 0 0 16px 0;

        .header-icon {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }

        .header-text {
          color: #FFFFFF;
          font-size: 14px;
          font-weight: normal;
        }
      }

      .header-stats {
        display: flex;
        gap: 16px;
        padding: 0 16px;

        span {
          font-size: 14px;
          color: #666666;
        }
      }
    }

    .more {
      padding: 0 16px;
      color: #666666;
      font-size: 14px;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }

  .section-content {
    padding: 16px;

    .video-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 12px;

      .video-item {
        overflow: hidden;
        cursor: pointer;
        .video-cover {
          position: relative;
          width: 100%;
          padding-bottom: 56.25%; // 16:9 比例
          border-radius: 4px;
          overflow: hidden;
          margin-bottom: 8px;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .video-info-overlay {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 8px;
            background: linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0));

            .views {
              color: #FFFFFF;
              font-size: 12px;
            }
          }
        }

        .video-title {
          font-size: 14px;
          color: #333333;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.paid-videos-section {
  position: relative;
  overflow: hidden;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      background: #FFF3F3;
      height: 100%;
      border-radius: 0 0 8px 0;
      font-size: 13px;

      .title-area {
        display: flex;
        align-items: center;
        background: #EA0000;
        height: 100%;
        padding: 0 20px;
        border-radius: 0 0 16px 0;

        .header-icon {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }

        .header-text {
          color: #FFFFFF;
          font-size: 14px;
          font-weight: normal;
        }
      }

      .header-stats {
        display: flex;
        gap: 16px;
        padding: 0 16px;

        span {
          font-size: 14px;
          color: #666666;
        }
      }
    }

    .more {
      padding: 0 16px;
      color: #666666;
      font-size: 14px;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }

  .section-content {
    padding: 16px;

    .video-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 12px;

      .video-item {
        cursor: pointer;
        overflow: hidden;

        .video-cover {
          position: relative;
          width: 100%;
          padding-bottom: 56.25%; // 16:9 比例
          border-radius: 4px;
          overflow: hidden;
          margin-bottom: 8px;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .video-info-overlay {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 8px;
            background: linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0));

            .views {
              color: #FFFFFF;
              font-size: 12px;
            }
          }
        }

        .video-info {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 8px;

          .video-title {
            flex: 1;
            font-size: 14px;
            color: #333333;
            line-height: 1.4;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .price {
            flex-shrink: 0;
            font-size: 14px;
            color: #FF0000;
            font-weight: 500;
          }
        }

        &:hover {
          .video-title {
            color: #EA0000;
          }
        }
      }
    }
  }
}

.operation-section {
  padding: 12px 16px;
  background: #F8F8F8;
  border: none;

  .operation-list {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .operation-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        .operation-text,
        .operation-count {
          color: #EF8432;
        }
        .operation-icon {
          transform: scale(1.1);
        }
      }

      .operation-icon {
        width: 16px;
        height: 16px;
        transition: transform 0.3s ease;
      }

      .operation-text {
        font-size: 13px;
        color: #666666;
        font-weight: normal;
        transition: color 0.3s ease;
      }

      .operation-count {
        font-size: 13px;
        color: #666666;
        margin-left: 4px;
        transition: color 0.3s ease;
      }
    }
  }
}
.remark-footer .el-button--primary {
  background-color: #EF8432 !important;
  border-color: #EF8432 !important;
}

.remark-footer .el-button--primary:hover {
  background-color: #e67722 !important;
  border-color: #e67722 !important;
}

.gift-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;

  .gift-item {
    text-align: center;
    background-color: #fff;
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      border-color: #EF8432;
    }

    &.active {
      border-color: #EF8432;
      box-shadow: 0 0 5px rgba(239, 132, 50, 0.5);
    }

    .gift-image {
      width: 60px;
      height: 60px;
      margin-bottom: 5px;
    }

    .gift-name {
      font-size: 12px;
      color: #333;
      margin-bottom: 2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .gift-price {
      font-size: 14px;
      color: #E4004E;
    }
  }
}

.loading-container {
  grid-column: span 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-radius: 50%;
    border-top: 3px solid #EF8432;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }

  p {
    color: #666;
    font-size: 14px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}

.empty-state {
  grid-column: span 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;

  .empty-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 16px;
  }

  .empty-text {
    color: #999;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Info.vue